import React from "react";

import { useAppType, useFeatureFlag, useGeneralContext, useLocation, useUserContext } from "utils";

import { ALL_FIELDS_MAP_VIEW_ROUTE, ALL_FIELDS_ROUTE, ALL_FIELDS_TABLE_VIEW_ROUTE, FEATURE_FLAGS } from "consts";

import { Alert, Breadcrumbs, Flex } from "components";

import { GlobalFarmSwitch } from "pages/app/_app/components/farm-switch/GlobalFarmSwitch";
import { FeatureFlagGate } from "pages/app/_app/components/feature-flag/FeatureFlagGate";
import { ProfileMenu } from "pages/app/_app/components/profile-menu/ProfileMenu.tsx";
import { FieldViewModeSwitcher } from "pages/app/all-field-view/components/FieldViewModeSwitcher";

export const HeaderDesktop = () => {
  const { referralBanner, fullWidthPage, railNavCollapsed, navigationCrumbs } = useGeneralContext();
  const { largeDesktop } = useAppType();
  const { user } = useUserContext();
  const location = useLocation();
  const { isEnabled: isViewSwitcherEnabled } = useFeatureFlag(FEATURE_FLAGS.FIELD_MANAGEMENT_VIEW_SWITCHER);

  const ReferralBanner = ({ text }: { text: string }) => (
    <Alert dataTestId="alert-banner" className="alert-banner" description={text} icon="" type="green" closable={true} onClick={() => {}} showArrow />
  );

  if (!user) {
    return <>{referralBanner && <ReferralBanner text={referralBanner.text} />}</>;
  }
  const isDigitalAgronomist = () => location?.pathname?.includes("/side-crop-recommender");

  const pathname = location?.pathname ?? "";
  const isAllFieldsRoute = pathname === ALL_FIELDS_ROUTE || pathname.startsWith(`${ALL_FIELDS_ROUTE}/`);
  const PATH_TO_MODE: Record<string, "table" | "map" | "timeline"> = { [ALL_FIELDS_TABLE_VIEW_ROUTE]: "table", [ALL_FIELDS_MAP_VIEW_ROUTE]: "map" };
  const activeMode = PATH_TO_MODE[pathname] ?? "timeline";
  const showSwitcher = isViewSwitcherEnabled && isAllFieldsRoute;

  return (
    <section
      className={`${isDigitalAgronomist() ? "digital-agronomist-container-width" : fullWidthPage ? "container-full-width" : "header-desktop nav-container"} ${
        railNavCollapsed || !largeDesktop ? "" : "menu-open"
      }`}
    >
      <Flex justify="center">
        <Flex className="header-desktop container" align="center" gap={".5rem"}>
          <Flex flex={1} align="center" gap="1rem" className="header-left">
            <FeatureFlagGate flag={FEATURE_FLAGS.GLOBAL_FARM_SWITCH}>
              {(farmSwitchEnabled) => {
                const crumbs = navigationCrumbs?.crumbs ?? [];
                const visibleCrumbs = farmSwitchEnabled ? crumbs.filter((crumb) => !crumb.replacedByFarmSwitch) : crumbs;

                return (
                  <>
                    {farmSwitchEnabled ? <GlobalFarmSwitch /> : null}
                    {visibleCrumbs.length ? (
                      <Breadcrumbs
                        className="breadcrumbs header"
                        dataTestId="breadcrumbs"
                        items={visibleCrumbs}
                        additionalData={navigationCrumbs.additionalData}
                        size="m"
                      />
                    ) : null}
                  </>
                );
              }}
            </FeatureFlagGate>
          </Flex>
          <Flex justify="center" flex={1}>
            {showSwitcher && <FieldViewModeSwitcher activeMode={activeMode} />}
          </Flex>
          <Flex align="center" justify="flex-end" flex={1} gap="1rem">
            <ProfileMenu />
          </Flex>
        </Flex>
      </Flex>
    </section>
  );
};
